import { Controller, useFormContext } from 'react-hook-form'

import { CurrencyCentInput, FF2, Validators } from 'ui/components'
import { SarEdit } from '~bank-bsa-reporting/types'

export const LossToFinInstitution = ({ index }: { index: number }) => {
  const { control } = useFormContext<SarEdit>()

  return (
    <Controller
      name={`institutionActivitiesInfo.${index as 0}.lossToFinInstitution`}
      control={control}
      rules={{
        validate: Validators.required.notEmpty
      }}
      render={({ field }) => (
        <FF2
          required
          label="67. Loss to financial institution"
          field={field}
          input={(props) => <CurrencyCentInput {...props} />}
        />
      )}
    />
  )
}
